import { useMemo } from 'react'
import { useSidebarProvider } from '../contexts/Sidebar'
import { searchNotes, SearchResult } from '../services/noteSearchService'
import { Note } from '../utils/note'

export interface AISearchData {
  privateProjectNotes?: Array<[string, Note]>
  privateCalendarNotes?: Array<[string, Note]>
  teamProjectNotes?: Array<[string, Note]>
  teamCalendarNotes?: Array<[string, Note]>
}

export function useAINoteSearch() {
  const {
    privateProjectNotes,
    privateCalendarNotes,
    teamProjectNotes,
    teamCalendarNotes,
    isInSpecialFolder,
  } = useSidebarProvider()

  // Prepare notes data for API transmission
  const notesData: AISearchData = useMemo(() => {
    return {
      privateProjectNotes: privateProjectNotes 
        ? Array.from(privateProjectNotes.entries())
        : undefined,
      privateCalendarNotes: privateCalendarNotes
        ? Array.from(privateCalendarNotes.entries())
        : undefined,
      teamProjectNotes: teamProjectNotes
        ? Array.from(teamProjectNotes.entries())
        : undefined,
      teamCalendarNotes: teamCalendarNotes
        ? Array.from(teamCalendarNotes.entries())
        : undefined,
    }
  }, [privateProjectNotes, privateCalendarNotes, teamProjectNotes, teamCalendarNotes])

  // Local search function (for potential future client-side search)
  const searchNotesLocal = (query: string, limit: number = 20): SearchResult[] => {
    const noteMaps = {
      privateProjectNotes,
      privateCalendarNotes,
      teamProjectNotes,
      teamCalendarNotes,
    }
    
    return searchNotes(query, noteMaps, isInSpecialFolder, limit)
  }

  return {
    notesData,
    searchNotesLocal,
    isInSpecialFolder,
  }
}